<div class="switch-wrapper">
  <span class="switch-text switch-text-left" [ngClass]="{ 'switch-text-active': isLeftActive }">{{ textLeft }}</span>
  <nz-switch [formControl]="control" [nzSize]="size"></nz-switch>
  <span class="switch-text switch-text-right" [ngClass]="{ 'switch-text-active': isRightActive }">{{ textRight }}</span>
</div>
